module.exports = __webpack_public_path__ + "img/Unassign.92b6db87.svg";